import { message } from "antd"
import { Dispatch } from "redux"
import { getAudiences } from "../../api/audienceApi"
import { AudiencesActionTypes, AudiencesAction } from "../types/audience"

const fetchAudiences = () => {
  return async (dispatch: Dispatch<AudiencesAction>) => {
    try {
      dispatch({
        type: AudiencesActionTypes.FETCH_AUDIENCES_LIST,
      })

      const audiences = await getAudiences()
      dispatch({
        type: AudiencesActionTypes.FETCH_AUDIENCES_LIST_SUCCESS,
        payload: audiences,
      })
    } catch (e) {
      message.error("Failed to load audiences")
      dispatch({
        type: AudiencesActionTypes.FETCH_AUDIENCES_LIST_ERROR,
        payload: "Audiences load error",
      })
    }
  }
}

export default {
  fetchAudiences,
}
